<template>
  <div
    class="flex items-center justify-center"
    :class="[sizeClass]"
    v-html="avatar.svg"
  ></div>
</template>

<script setup>
import { computed } from 'vue'
import { getAvatarById } from '@/config/avatars'

const props = defineProps({
  avatarId: {
    type: String,
    default: 'lotus'
  },
  size: {
    type: String,
    default: 'md',
    validator: (v) => ['sm', 'md', 'lg'].includes(v)
  }
})

const avatar = computed(() => getAvatarById(props.avatarId))

const sizeClass = computed(() => ({
  sm: 'w-7 h-7',
  md: 'w-10 h-10',
  lg: 'w-14 h-14',
}[props.size]))
</script>
